module.exports = __webpack_public_path__ + "static/img/phone.68b674d1.png";